import React from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';

import { Button, Link } from 'gatsby-theme-material-ui';
import CountdownTimer from '../../CountdownTimer/CountdownTimer';
import LongArrowSvg from './LongArrowSvg';

export default function VioletTimerBanner({
  banner,
  isMobile,
  setIsModalOpen,
  setShowBanner,
  handleClick,
}) {
  const isBelowLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const expireDateTimestamp = new Date(banner.expireDate).getTime();
  let buttonHandle = null;
  if (banner.buttonAction === 'modal') {
    buttonHandle = () => setIsModalOpen && setIsModalOpen(true);
  }
  if (banner.buttonAction === 'link') {
    buttonHandle = handleClick;
  }
  const button = (
    <Button
      size={isBelowLg ? 'smallest' : 'medium'}
      variant="kitPrimary"
      onClick={buttonHandle}
      sx={{ height: 'fit-content', minWidth: 91 }}
    >
      {banner.buttonText?.split(' ').join(' ')}
    </Button>
  );
  return (
    <Box
      sx={{
        height: { xs: 40, md: 80 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#734AE2',
            position: 'relative',
          }}
        />
      </Box>
      <Container
        maxWidth={'xl'}
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          gap: { xs: 2, md: 4, xl: 6 },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            minWidth: 157,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="desktopH5"
            sx={{
              color: 'kit.text.mainInverse',
              fontSize: { xs: 12, sm: 14, md: 18, lg: 20 },
              fontWeight: 400,
              minWidth: 161,
            }}
          >
            {isMobile
              ? banner.bannerMobileText.split('\\n')[0]
              : banner.bannerDesktopText.split('\\n')[0]}
          </Typography>

          <LongArrowSvg isMobile={isMobile} />
          <Typography
            variant="desktopH5"
            sx={{
              color: 'kit.text.mainInverse',
              fontSize: { xs: 12, sm: 14, md: 18, lg: 20 },
              fontWeight: 400,
            }}
          >
            {isMobile
              ? banner.bannerMobileText.split('\\n')[1]
              : banner.bannerDesktopText.split('\\n')[1]}
          </Typography>
        </Box>

        {banner.buttonAction === 'link' && (
          <Link
            href={banner.buttonLink}
            target="_blank"
            underline="none"
            children={button}
          />
        )}
        {banner.buttonAction === 'modal' && button}
        <Box>
          <Typography
            component={'div'}
            variant="desktopH4"
            sx={{
              fontSize: { xs: 12, lg: 24 },
              color: 'kit.text.mainInverse',
              letterSpacing: { xs: -1, lg: '-3px' },
              display: { xs: 'none', md: 'block' },
            }}
          >
            <CountdownTimer
              timestamp={expireDateTimestamp}
              setShowBanner={setShowBanner}
            />
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
